/* "Series" slider on collection pages (sections/custom-collection-series.liquid). */

window.Blundstone = window.Blundstone || {};

(() => {
  if (customElements.get('collection-series-slider')) return;

  class CollectionSeriesSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.collection-series__track');
      this.prevButton = this.querySelector('.collection-series__arrow--prev');
      this.nextButton = this.querySelector('.collection-series__arrow--next');
      if (!this.track) return;

      this.onScroll = () => this.updateArrows();
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll);

      if (this.prevButton) this.prevButton.addEventListener('click', () => this.scrollByPage(-1));
      if (this.nextButton) this.nextButton.addEventListener('click', () => this.scrollByPage(1));

      this.updateArrows();
    }

    disconnectedCallback() {
      if (this.track) this.track.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
    }

    get step() {
      const firstCard = this.track.querySelector('li');
      if (!firstCard) return this.track.clientWidth;
      const gap = parseFloat(window.getComputedStyle(this.track).columnGap) || 0;
      return firstCard.getBoundingClientRect().width + gap;
    }

    scrollByPage(direction) {
      this.track.scrollBy({ left: this.step * direction, behavior: 'smooth' });
    }

    updateArrows() {
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      const atStart = this.track.scrollLeft <= 1;
      const atEnd = this.track.scrollLeft >= maxScroll - 1;
      if (this.prevButton) this.prevButton.hidden = maxScroll <= 1 || atStart;
      if (this.nextButton) this.nextButton.hidden = maxScroll <= 1 || atEnd;
    }
  }

  customElements.define('collection-series-slider', CollectionSeriesSlider);
  window.Blundstone.CollectionSeriesSlider = CollectionSeriesSlider;
})();
